import type { ComponentType } from "react";
import { WhatsAppOutlined } from "@ant-design/icons";
import { Mail } from "lucide-react";
import type { CampaignChannel } from "../../EngagementInterfaces";

export interface CampaignChannelOption {
  value: CampaignChannel;
  labelKey: string;
  Icon: ComponentType<{ className?: string }>;
}

export const CAMPAIGN_CHANNEL_OPTIONS: CampaignChannelOption[] = [
  {
    value: "whatsapp",
    labelKey: "campaignFlow.createCampaignNew.channelWhatsApp",
    Icon: WhatsAppOutlined,
  },
  {
    value: "email",
    labelKey: "campaignFlow.createCampaignNew.channelEmail",
    Icon: Mail,
  },
];

export const UNSUBSCRIBED_LIST_KEYWORD = "unsubscribed";
export const AUDIENCE_SEPARATOR = ", ";
export const COMPANY_NAME_STORAGE_KEY = "company_name_engagements";
export const SITEMAP_MESSAGE_KEY = "sitemap-info";
export const SITEMAP_MESSAGE_DURATION_SECONDS = 5;
export const AI_EMAIL_EDITOR_ROUTE = "/account/engagement/ai-email-editor";
export const TEMPLATE_EMAIL_EDITOR_ROUTE = "/account/engagement/email-template-editor";
export const WHATSAPP_CAMPAIGN_EDITOR_ROUTE = "/account/engagement/whatsapp-campaign-editor";
export const CAMPAIGN_ANALYTICS_ROUTE = "/account/engagement/campaign-analytics";
